const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function registerSW() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
}

export async function enablePush(api) {
  if (!pushSupported()) throw new Error(isIOS() ? "ios" : "unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const reg = await navigator.serviceWorker.ready;
  const { public_key } = await api("get", "/push/vapid");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(public_key) });
  await api("post", "/push/subscribe", sub.toJSON());
}

export async function disablePush(api) {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await api("post", "/push/unsubscribe", sub.toJSON());
  await sub.unsubscribe();
}

export async function syncPush(api) {
  if (!pushSupported() || Notification.permission !== "granted") return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) await api("post", "/push/subscribe", sub.toJSON());
}

let deferredInstall = null;
const installListeners = new Set();
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredInstall = e;
  installListeners.forEach((fn) => fn(e));
});
export const getInstallPrompt = () => deferredInstall;
export const takeInstallPrompt = () => { const p = deferredInstall; deferredInstall = null; return p; };
export const onInstallPrompt = (fn) => { installListeners.add(fn); return () => installListeners.delete(fn); };
